import { render, staticRenderFns } from "./Use.vue?vue&type=template&id=d2b85a22&"
import script from "./Use.vue?vue&type=script&lang=js&"
export * from "./Use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports